// import { useState } from "react";
import { ExternalLink, Github } from "lucide-react";
// import Uiux from "./uiux";
// import Frontndback from "./frontndback";
// import VsCodeEX from "./vsCodeExtension.jsx";
import image1 from './../asserts/porject_image/1.png'
import image2 from './../asserts/porject_image/2.png'
import image3 from './../asserts/porject_image/3.png'
import image4 from './../asserts/porject_image/4.png'
import image5 from './../asserts/porject_image/5.png'
import image6 from './../asserts/porject_image/6.png'
import image7 from './../asserts/porject_image/7.png'
import image8 from './../asserts/porject_image/8.png'
import image9 from './../asserts/porject_image/9.png'
import image10 from './../asserts/porject_image/10.png'
import extensionlogo from './../asserts/logo.png'
import image11 from './../asserts/porject_image/image.png'
// import VsCodeExtension from'./vsCodeExtension'
export default function Projects() {
    // const [filter, setFilter] = useState("all");
    const filteredProjects = [
        {
            "id": "1",
            "title": "Yatras Cooking Cave",
            "alt": "yatrascookingcave",
            "img": image10,
            "url": "https://www.yatrascookingcave.com/"
            // "Gitsource": ""
        },
        {
            "id": "2",
            "title": "Max Portfolio",
            "alt": "max Portfolio (Freelance work)",
            "img": image11,
            "url": "https://max-chi-five.vercel.app/"
        },
        {
            "id": "3",
            "title": "Run Python Live ( Vs Code Extension)",
            "alt": "Run Python Live",
            "img": extensionlogo,
            "url": "https://marketplace.visualstudio.com/items?itemName=RunPythonLive.run-python-live",
            "Gitsource": "https://github.com/Othi-Raja/run-python-live",
        },
        {
            "id": "4",
            "title": "Mr.Chef",
            "alt": "Mr.Chef",
            "img": image8,
            "url": "https://othi-raja.github.io/Mr.chef-/",
            "Gitsource": "https://github.com/Othi-Raja/Mr.chef-"
        },
        {
            "id": "5",
            "title": "Sorting",
            "alt": "Sorting",
            "img": image3,
            "url": "https://othi-raja.github.io/simple/",
            "Gitsource": "https://github.com/Othi-Raja/simple"
        },
        {
            "id": "6",
            "title": "WowClothes.com",
            "alt": "WowClothes.com",
            "img": image2,
            "url": "https://othi-raja.github.io/Wowclothes_landing_Page/",
            "Gitsource": "https://github.com/Othi-Raja/Wowclothes_landing_Page"
        },
        {
            "id": "7",
            "title": "UrbanRider",
            "alt": "UrbanRider",
            "img": image9,
            "url": "https://urbanrider.in/"
        },
        {
            "id": "8",
            "title": "GoExtraMile",
            "alt": "goextramile",
            "img": image1,
            "url": "https://www.goextramile.in/"
        },
        {
            "id": "9",
            "title": "Amjathkhan",
            "alt": "Amjathkhan",
            "img": image4,
            "url": "https://amjathkhan.netlify.app/"
            ,
            "Gitsource": "https://github.com/Othi-Raja/Amjathkhan."
        },
        {
            "id": "10",
            "title": "HinaArora",
            "alt": "HinaArora",
            "img": image7,
            "url": "https://hinaarora.netlify.app/"
            ,
            "Gitsource": "https://github.com/Othi-Raja/Hina-Arora"
        },
        {
            "id": "11",
            "title": "Tanvi Khandelwal",
            "alt": "Tanvi",
            "img": image6,
            "url": "https://tanvi-khandelwal.netlify.app/"
            ,
            "Gitsource": "https://github.com/Othi-Raja/tanvi-khandelwal-nextjs"
        },
        {
            "id": "12",
            "title": "Deepika",
            "alt": "Deepika",
            "img": image5,
            "url": "https://deepika-saini.netlify.app/"
            ,
            "Gitsource": "https://github.com/Othi-Raja/tanvi-khandelwal-nextjs"
        }
    ];
    const sortedProjects = [...filteredProjects].sort((a, b) => {
        if (b.Gitsource && !a.Gitsource) return -1; // a comes first
        if (!b.Gitsource && a.Gitsource) return 1;  // b comes first
        return 0; // keep original order otherwise
    });
    return (
        <section id="projects" className="bg-white dark:bg-[#121212] py-20 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="relative inline-block mb-8 text-center">
                    <h2
                        className="font-bold text-[48px] md:text-[64px] leading-[1.1] text-black dark:text-white"
                        style={{
                            fontFamily: "Plus Jakarta Sans, sans-serif",
                            letterSpacing: "-0.02em",
                        }}
                        data-aos="fade-in"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                    >
                        Projects
                    </h2>
                    <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2">
                        <svg width="120" height="6" viewBox="0 0 120 6" fill="none">
                            <path
                                d="M2 3C30 1 60 1 90 3C95 3.5 110 4 118 3"
                                stroke="#3B82F6"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
                {/* Section heading */}
                {/* <div className="mb-16 text-center">
                    <div className="relative inline-block">
                        <h2
                            className="font-bold text-[48px] md:text-[64px] leading-[1.1] text-black dark:text-white"
                            style={{
                                fontFamily: "Plus Jakarta Sans, sans-serif",
                                letterSpacing: "-0.02em",
                            }}
                        >
                            My Projects
                        </h2>
                        <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2">
                            <svg width="160" height="6" viewBox="0 0 160 6" fill="none">
                                <path
                                    d="M2 3C30 1 60 1 90 3C120 1 130 2 158 3"
                                    stroke="#F59E0B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                    </div>
                </div> */}
                {/* Projects grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
                    {sortedProjects.sort((a, b) => a.id - b.id).map((project) => (
                        <div
                            key={project.id}
                            className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200 hover:shadow-2xl hover:scale-105 transition-all duration-300"
                        >
                            {/* Project image */}
                            <div className="relative overflow-hidden">
                                <img loading="lazy"
                                    src={project.img}
                                    alt={project.alt}
                                    className="w-full h-48 object-cover group-hover:scale-110 transition-all duration-300"
                                />
                            </div>
                            {/* Project content */}
                            <div className="p-6">
                                <h3
                                    className="font-bold text-[18px] text-black mb-3 group-hover:text-blue-600 transition-colors"
                                    style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}
                                >
                                    {project.title}
                                </h3>
                                {/* Action buttons */}
                                <div className="flex gap-3">
                                    {project.Gitsource && (
                                        <a
                                            href={project.Gitsource}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex-1 flex items-center justify-center gap-2 border border-gray-300 text-black hover:border-blue-600 hover:text-blue-600 py-2 px-4 rounded-lg transition-all duration-300 text-sm font-medium"
                                        >
                                            <Github size={16} />
                                        </a>
                                    )}
                                    <a
                                        href={project.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-2 px-4 rounded-lg transition-all duration-300 text-sm font-medium"
                                    >
                                        <ExternalLink size={16} />
                                        View Project
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* <VsCodeEX /> */}
        </section>
    );
}